import React from "react";

const PageNotFound = () => {
	return <div>You divided by zero, didn't you?</div>;
};

export default PageNotFound;
